import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-driver-energy-slider',
  templateUrl: './driver-energy-slider.component.html',
  styleUrl: './driver-energy-slider.component.scss'
})
export class DriverEnergySliderComponent extends BaseComponent{

    displayName: string = '';

    /** icon name (e.g. Material icon ligature, or font-awesome class) */
    @Input() icon = 'star';
    /** any CSS color string (hex, rgb…) */
    @Input() baseColor = '#3f51b5';

    // @Input() name: string;
    @Input() name : string = '';  
    /** emits when the value changes */
    @Output() valueChange = new EventEmitter<number>();
  
    @HostBinding('style.--curr-color') get _getBaseColor() {
      return this.baseColor;
    }

    /** allow styling track/handle via CSS custom props */
    @HostBinding('style.--curr-color') get _getCurrColor() {
      if (this._value == 0){
        return this.untouchedColor;
      }
      else{
        return this.baseColor;
      }
    }

    get isTouched() : boolean {
      return this._value > 0;
    }

    @HostBinding('style.--track-color') get _trackColor() {
      // make a 20%-alpha version of baseColor
      const hex = this.baseColor.replace('#', '');
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      return `rgba(${r},${g},${b},.2)`;
    }
  
    @HostBinding('style.--border-color')
    get hostBorderColor(): string {
      // pick whichever color is actually shown
      const hex = (this.value > 0 ? this.baseColor : this.baseColor).replace('#', '');
      const num = parseInt(hex, 16);
      let r = (num >> 16) & 0xff;
      let g = (num >> 8) & 0xff;
      let b = num & 0xff;
      // darken by 20%
      r = Math.round(r * 0.8);
      g = Math.round(g * 0.8);
      b = Math.round(b * 0.8);
      // pad to two digits
      const rr = r.toString(16).padStart(2, '0');
      const gg = g.toString(16).padStart(2, '0');
      const bb = b.toString(16).padStart(2, '0');
      
      // add hexa for 20% opacity
      return `#${rr}${gg}${bb}33`;
    }

    /** internal value 0–5 */
    private untouchedColor = '#AAAAAA';
    private _value = 0;
    private _currColor = '';
    get value() {
      return this._value;
    }
    set value(v: number) {
      this._value = Math.min(5, Math.max(0, Math.round(v)));
      this.onChange(this._value);
      this.valueChange.emit(this._value);
    }
  
    /** ticks array [0,1,2,3,4,5] */
    ticks = Array.from({ length: 6 }, (_, i) => i);
  
    constructor() {
      super();
    }

    // ControlValueAccessor
    onChange = (v: number) => {
      // console.log(`onChange: ${v}`);
      if (v == 0){
        this._currColor = this.untouchedColor;
      }
      else{
        this._currColor = this.baseColor;
      }
    };
    onTouched = () => {};
    writeValue(v: number) {
      if (v != null) this._value = Math.min(5, Math.max(0, Math.round(v)));
    }
    registerOnChange(fn: any) {
      this.onChange = fn;
    }
    registerOnTouched(fn: any) {
      this.onTouched = fn;
    }
  
    /** click on the track to jump the thumb */
    onTrackClick(e: MouseEvent) {
      const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
      const clickY = e.clientY - rect.top;
      const ratio = 1 - clickY / rect.height;
      this.value = Math.round(ratio * 5);
      this.onTouched();
      // this.onChange(this.value);
    }

}
